<template>
  <h1>404</h1>
  <p>This is a page that really really doesn't exist.</p>
</template>


<script>
export default {
}
</script>

<style>
p {
  text-align: left;
  margin: 20px;
  padding: 4px;
}
</style>